import toggleMobileNav from "./modules/toggle-mobile-nav";
import toggleDropdown from "./modules/toggle-dropdown";
import initSliders from "./modules/init-sliders";
import initFilter from "./modules/residences-filter/init-filter";
import toggleLocations from "./modules/toggle-locations";
import initGallery from "./modules/init-gallery";
import animateFormLabel from "./modules/animate-form-label";
import initResidencesLinks from "./modules/init-residences-links";
import initLegendsCounter from "./modules/init-legends counter";
import initModals from "./modules/init-modals";
import populateUTMParameters from "./modules/populate-utm-parameters";

toggleMobileNav();
toggleDropdown();
initSliders();
initFilter();
toggleLocations();
initGallery();
animateFormLabel();
initResidencesLinks();
initLegendsCounter();
initModals();
populateUTMParameters();

const contactUsHandler = async () => {
	const form = document.forms['contact-us'];
	if (form) {
		const agentRadioGroup = form.querySelector('#re-agent');
		const agentsNameHolder = form.querySelector('#agents-name');
		const agentsNameInput = agentsNameHolder.querySelector('input');
		
		form.elements.broker.forEach((input) => {
			input.addEventListener('change', () => {
				
				if (form.elements.broker.value === 'no') {
					agentRadioGroup.classList.remove('radio-group--hidden');
				} else {
					agentRadioGroup.classList.add('radio-group--hidden');
					agentsNameHolder.classList.add('form__row--hidden');
					agentsNameInput.required = false;
					agentsNameInput.value = '';
					
					form.elements.agent.forEach((inputAgent) => {
						inputAgent.checked = false;
					});
					
				}
			});
		});
		
		form.elements.agent.forEach((input) => {
			input.addEventListener('change', () => {
				
				if (form.elements.agent.value === 'yes') {
					agentsNameHolder.classList.remove('form__row--hidden');
					agentsNameInput.required = true;
				} else {
					agentsNameHolder.classList.add('form__row--hidden');
					agentsNameInput.required = false;
					agentsNameInput.value = '';
				}
			});
		});
		
		// form.addEventListener('submit', async (evt) => {
			// evt.preventDefault();
			// grecaptcha.ready(() => {
			// 	grecaptcha.execute('reCAPTCHA_6LeDbz0lAAAAAIEFy0WMjPuIY7cP4baxb9QAQdSH', {action: 'submit'}).then(async (token) => {
			// 		console.log(token);
			// 		const formData = new FormData(form);
			// 		let body = '';
			//
			// 		for (let [name, value] of formData) {
			// 			body += `&${name}=${value}`;
			// 		}
			//
			// 		const response = await fetch('/wp-admin/admin-ajax.php', {
			// 			method: 'POST',
			// 			headers: {
			// 				'Content-Type': 'application/x-www-form-urlencoded'
			// 			},
			// 			body: `action=mason_park_form_submission_action&${body}`
			// 		});
			//
			// 		const data = await response.json();
			// 		if (data.success) {
			// 			document.querySelector('.contact__response').classList.add('contact__response--active');
			// 		}
			// 	});
			// });
			
			
			// evt.preventDefault();
			// const formData = new FormData(form);
			// let body = '';
			//
			// for (let [name, value] of formData) {
			// 	body += `&${name}=${value}`;
			// }
			//
			// const response = await fetch('/wp-admin/admin-ajax.php', {
			// 	method: 'POST',
			// 	headers: {
			// 		'Content-Type': 'application/x-www-form-urlencoded'
			// 	},
			// 	body: `action=mason_park_form_submission_action&${body}`
			// });
			//
			// const data = await response.json();
			// if (data.success) {
			// 	document.querySelector('.contact__response').classList.add('contact__response--active');
			// }
		// });
		
	}
};

contactUsHandler();
